import LinkPlanModal from './LinkPlanModal'

export default LinkPlanModal